"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

var TopicHeader = function TopicHeader(_ref) {
  var title = _ref.title,
      contentType = _ref.contentType,
      publicLabel = _ref.publicLabel,
      productAreas = _ref.productAreas,
      publishedAt = _ref.publishedAt,
      replies = _ref.replies,
      views = _ref.views;
  return (0, _preact.h)("header", {
    className: "topic__header qa-topic-header"
  }, Boolean(publicLabel) && (0, _preact.h)("span", {
    className: "topic__content-type-pill pill pill--uppercase pill--".concat(contentType, " qa-content-type-pill")
  }, publicLabel), (0, _preact.h)("h1", {
    className: (0, _classnames.default)('h3', 'topic__title', 'qa-thread-title')
  }, title), productAreas ? productAreas.length > 0 && (0, _preact.h)("div", {
    className: "m-v-S"
  }, (0, _preact.h)("span", {
    className: "text--meta"
  }, (0, _preact.h)(_phrase.default, {
    p: "product.areas.related.products"
  })), productAreas.map(function (productArea, index) {
    return (0, _preact.h)("span", {
      key: index,
      className: "text--dot-underline product-area-item"
    }, ' ', productArea.name, ' ');
  })) : null, (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta', 'm-v-S', 'qa-topic-meta')
  }, (0, _preact.h)("li", null, publishedAt ? _common.common.relativeDate(publishedAt) : (0, _preact.h)(_phrase.default, {
    p: "topic.meta.not_published"
  })), (0, _preact.h)("li", {
    className: "qa-link-to-replies"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "topic.meta.reply",
    count: {
      n: replies.toString()
    }
  })), (0, _preact.h)("li", {
    className: "is-hidden-S qa-count-views"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "topic.meta.views",
    count: {
      n: views.toString()
    }
  }))));
};

var _default = TopicHeader;
exports.default = _default;